import Description from "@/partials/elements/Description";
import Headline from "@/partials/elements/Headline";
import React from "react";
import Button from "../EventButtons/Button";
import FlexSection from "@/partials/sections/Section/FlexSection";
import GridSection from "@/partials/sections/Section/GridSection";

export default function Conference() {
  return (
    <GridSection extraClass={"grid-rows-1"}>
      <FlexSection extraClass=" flex-col gap-5">
        <Headline
          text={"Conducting Professional"}
          subText={"Events & Conferences"}
          extraClass={"text-lg md:text-[28px] text-[#000] max-w-52"}
        />
        <Description
          text={
            "To promote excellence in surgical practice, foster professional development among its members, and facilitate the exchange of knowledge and ideas within the surgical community."
          }
          extraClass={"max-w-86 "}
        />
      </FlexSection>
      <FlexSection extraClass="gap-4 justify-center md:justify-start">
        <Button text="Events & Conferences" link={"/events"} />
      </FlexSection>
    </GridSection>
  );
}
